import { render, staticRenderFns } from "./DropdownMenuList.vue?vue&type=template&id=72143452&scoped=true&"
import script from "./DropdownMenuList.vue?vue&type=script&lang=js&"
export * from "./DropdownMenuList.vue?vue&type=script&lang=js&"
import style0 from "./DropdownMenuList.vue?vue&type=style&index=0&id=72143452&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72143452",
  null
  
)

export default component.exports